module.exports = __webpack_public_path__ + "img/singVerify-success.b2afbc4d.png";